// DashboardGrid.js - Responsive grid layout for dashboard widgets
import React from 'react';

const DashboardGrid = ({ children, className = '' }) => {
  return (
    <div className={`grid gap-6 ${className}`}>
      {children}
    </div>
  );
};

// Preset grid layouts
DashboardGrid.Row = ({ children, cols = 2, className = '' }) => {
  const colClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 lg:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4',
    6: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6'
  };

  return (
    <div className={`grid gap-4 ${colClasses[cols] || colClasses[2]} ${className}`}>
      {children}
    </div>
  );
};

// Full width section
DashboardGrid.Full = ({ children, className = '' }) => {
  return (
    <div className={`col-span-full ${className}`}>
      {children}
    </div>
  );
};

// Stat card for overview metrics
DashboardGrid.StatCard = ({ label, value, subValue, trend, children, className = '' }) => {
  const trendValue = parseFloat(trend);
  const trendColor = trendValue > 0 ? 'text-green-400' : trendValue < 0 ? 'text-red-400' : 'text-gray-400';

  return (
    <div className={`bg-gray-800 rounded-lg p-4 ${className}`}>
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <div className="text-gray-400 text-sm">{label}</div>
          <div className="text-2xl font-bold mt-1 text-white">{value}</div>
          {subValue && <div className="text-gray-500 text-sm">{subValue}</div>}
          {children}
        </div>
        {trend !== undefined && (
          <div className={`text-sm ${trendColor}`}>
            {trendValue >= 0 ? '+' : ''}{trend}%
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardGrid;
